import { render, staticRenderFns } from "./EditVote1.vue?vue&type=template&id=5a4264cb"
import script from "./EditVote1.vue?vue&type=script&lang=js"
export * from "./EditVote1.vue?vue&type=script&lang=js"
import style0 from "./EditVote1.vue?vue&type=style&index=0&id=5a4264cb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports